var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.667,
    height: 23.089,
    viewBox: "0 0 47.667 23.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a61c14;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 132)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M47.121,142.226l0,0-9.729-9.682a1.862,1.862,0,0,0-2.627,2.64l6.532,6.5H1.862a1.862,1.862,0,1,0,0,3.724H41.295l-6.532,6.5a1.862,1.862,0,0,0,2.627,2.64l9.729-9.682,0,0A1.864,1.864,0,0,0,47.121,142.226Z",
    transform: "translate(0 -132)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowRed);
export default __webpack_public_path__ + "static/media/right-arrow-red.208d2822a049181ef99ae897008c2e2e.svg";
export { ForwardRef as ReactComponent };